import axios from "axios"
import { getUser } from "helpers/auth-helper"
import { json } from "react-router-dom"

export const getByUser = async ({ params }) => {
    const user = getUser()

    // Loader jalan sebelum element di-render, jadi setelah logout (session
    // sudah dihapus) user bisa null. Jangan panggil API — kembalikan list
    // kosong dan biarkan ProtectedRoute yang redirect ke /login.
    if (!user?.id) return []

    return axios.get(`${process.env.REACT_APP_GENERIC_API_URL}/branch/by`, {
        params: {
            user_id: user.id
        }
    }).then(res => res.data.data).catch((error) => {
        throw new json(error, error.response?.status ?? 500)
    })
}